import React from 'react';
import AnimalGallery from './components/AnimalGallery';
import './App.css';

function App() {
  return (
    <div className="App">
      <AnimalGallery />
    </div>
  );
}

export default App;
